/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult,
  FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand,
} from '../models/index';
import {
    FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultFromJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultToJSON,
    FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandFromJSON,
    FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandToJSON,
} from '../models/index';

export interface FxIdWebFeaturesPromoCodesRedeemRedeemPromoCodeEndpointRequest {
    fxIdApplicationSharedPromoCodesRedeemPromoCodeCommand: FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand;
}

/**
 * 
 */
export class PromoCodeApi extends runtime.BaseAPI {

    /**
     * **MUTATES:** `promo_codes`    Redeems promocode  
     */
    async fxIdWebFeaturesPromoCodesRedeemRedeemPromoCodeEndpointRaw(requestParameters: FxIdWebFeaturesPromoCodesRedeemRedeemPromoCodeEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult>> {
        if (requestParameters['fxIdApplicationSharedPromoCodesRedeemPromoCodeCommand'] == null) {
            throw new runtime.RequiredError(
                'fxIdApplicationSharedPromoCodesRedeemPromoCodeCommand',
                'Required parameter "fxIdApplicationSharedPromoCodesRedeemPromoCodeCommand" was null or undefined when calling fxIdWebFeaturesPromoCodesRedeemRedeemPromoCodeEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/promo-code/redeem`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationSharedPromoCodesRedeemPromoCodeCommandToJSON(requestParameters['fxIdApplicationSharedPromoCodesRedeemPromoCodeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResultFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `promo_codes`    Redeems promocode  
     */
    async fxIdWebFeaturesPromoCodesRedeemRedeemPromoCodeEndpoint(fxIdApplicationSharedPromoCodesRedeemPromoCodeCommand: FxIdApplicationSharedPromoCodesRedeemPromoCodeCommand, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxGamesLibWebRpcContractsFxGamesResponseOfRedeemPromoCodeResult> {
        const response = await this.fxIdWebFeaturesPromoCodesRedeemRedeemPromoCodeEndpointRaw({ fxIdApplicationSharedPromoCodesRedeemPromoCodeCommand: fxIdApplicationSharedPromoCodesRedeemPromoCodeCommand }, initOverrides);
        return await response.value();
    }

}
